/**
 * Circuits view: one row per SLC/NAC loop with device count, wire length,
 * worst-case voltage, and a pass/check badge from the engine's capacity +
 * voltage-drop checks (US vocabulary per NFPA 72 — spec §2 item 2).
 */
import type { MepCircuit } from "../api/types";

function fmt(value: number | null, unit: string, digits: number): string {
  return value === null ? "—" : `${value.toFixed(digits)} ${unit}`;
}

export function CircuitsPanel({ circuits }: { circuits: MepCircuit[] }) {
  if (circuits.length === 0) {
    return (
      <p data-testid="circuits-empty" style={{ color: "#8e8eb8" }}>
        No circuits yet.
      </p>
    );
  }
  return (
    <ul data-testid="circuits-panel" style={{ listStyle: "none", margin: 0, padding: 0 }}>
      {circuits.map((circuit) => (
        <li
          key={circuit.id}
          data-testid="circuit-row"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            background: "#21213a",
            borderRadius: 8,
            padding: "0.5rem 0.75rem",
            marginBottom: "0.35rem",
            fontSize: "0.85rem",
          }}
        >
          <span
            style={{
              fontFamily: "monospace",
              textTransform: "uppercase",
              color: "#c678dd",
              minWidth: 40,
            }}
          >
            {circuit.kind}
          </span>
          <span style={{ flex: 1 }}>{circuit.device_ids.length} devices</span>
          <span style={{ color: "#8e8eb8" }}>{fmt(circuit.wire_length_m, "m", 1)}</span>
          <span style={{ color: "#8e8eb8" }}>{fmt(circuit.worst_voltage_v, "V", 2)}</span>
          <span
            data-testid="circuit-ok"
            style={{
              padding: "0.05rem 0.5rem",
              borderRadius: 999,
              fontSize: "0.72rem",
              fontWeight: 600,
              color: "#12121e",
              background: circuit.ok ? "#98c379" : "#e06c75",
            }}
          >
            {circuit.ok ? "OK" : "CHECK"}
          </span>
        </li>
      ))}
    </ul>
  );
}
